export var allocationKeys={sector:'sector',currency:'currencyName',region:'region'};